var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-view"},[_c('Heading'),_c('div',{staticClass:"flex flex-auto"},[_c('ProfileList'),_c('div',{staticClass:"main"},[_c('ProfilePage')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }